import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import objectAssign from 'object-assign';
import {StickyContainer, Sticky} from 'react-sticky';
import 'matchmedia-polyfill';
import 'classlist-polyfill';
import 'core-js/modules/es.symbol.iterator.js';
import 'core-js/modules/es.array.find-index.js';
import 'core-js/modules/es.typed-array.iterator.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.find.js';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.promise.js';
import raf from 'raf';
import throttle from 'lodash.throttle';
import * as orderActions from '../actions/orderActions';
import * as appearanceActions from '../actions/appearanceActions';
import * as errorsActions from '../actions/errorsActions';
import RentalInformation from '../components/RentalInformation';
import BookingStepsContainer from './BookingStepsContainer';
import BookingOverview from '../components/BookingOverview';
import ExtraServices from '../components/ExtraServices';
import TicketPanels from '../components/TicketPanels';
import AgencySubId from '../components/AgencySubId';
import TravelAgencyOptions from '../components/TravelAgencyOptions';
import CustomerContactInfo from '../components/CustomerContactInfo';
import PaymentSectionRates from '../components/PaymentSectionRates';
import AppearanceContext from '../context/AppearanceContext';
import sticky from '../assets/js/sticky';
import DIBS from '../components/DIBS';
import AbandonBasketModal from '../components/AbandonBasketModal';
import FreeCancellationInfo from "../components/FreeCancellationInfo";
import TimeoutModal from '../components/TimeoutModal';

/**
 * This value MUST be the same as the sidebarred value in Sass
 * _variables partial.
 */
const breakpoint = 1025;
class App extends Component {
  constructor(props) {
    super(props);
    this.calcIsNarrow = this.calcIsNarrow.bind(this);
    this.getWrappedBookingOverview = this.getWrappedBookingOverview.bind(this);
  }

  componentWillMount() {
    if (process.env.NODE_ENV === 'production') { // eslint-disable-line global-require
      const elem = document.querySelector('.loading').classList;

      if ('animation' in document.body.style) {
        elem.add('loading--active');
      }
      else {
        elem.add('loading--active-no-anim');
      }

      // Trigger animation.
      document.querySelector('.booking').classList.add('booking--loading');
      document.querySelector('.booking--loading').classList.remove('booking--loading');
    }

    const loading = document.querySelector('.loading--active, .loading--active-no-anim');

    if (loading !== null) {
      loading.classList.remove('loading--active');
    }

    this.calcIsNarrow();
  }

  componentDidMount() {
    const bookingComp = ReactDom.findDOMNode(this).parentNode; // eslint-disable-line react/no-find-dom-node
    bookingComp.style.opacity = 0;
    raf(() => {
      bookingComp.style.transition = 'opacity 1s';
      bookingComp.style.opacity = 1;
    });

    window.addEventListener('resize',
      throttle(this.calcIsNarrow,
        100),
      false);

    sticky({
      container: document.getElementById('booking-wrap'),
      elementSelector: '.booking-overview-wrap',
      offsetTop: -28,
      offsetBottom: 48,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.appearance.needsUpdateFromBackend) {
      this.props.actions.requestFromBackend(nextProps.order);
    }
    if (nextProps.appearance.needsValidateVoucher) {
      this.props.actions.validateVoucher(nextProps.order);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize',
      throttle(this.calcIsNarrow,
        100),
      false);
  }

  getWrappedBookingOverview({ isSticky }) {
    const allProps = this.getAllProps();
    const overviewClassNames = ['sticky-overview'];
    if (allProps.appearance.bookingOverviewExpanded) {
      overviewClassNames.push('sticky-overview--full');
    }
    if (isSticky) {
      overviewClassNames.push('sticky-overview--stuck');
    }
    return (
      <div className={overviewClassNames.join(' ')}>
        <BookingOverview {...allProps} main />
      </div>
    );
  }

  getAllProps() {
    return {
      appearance: this.props.appearance,
      dispatchScrollToInvalid: this.props.dispatchScrollToInvalid,
      order: this.props.order,
      rental: this.props.rental,
      errors: this.props.errors,
      actions: this.props.actions,
      validatorFactory: this.props.validatorFactory,
    };
  }

  /**
   * @todo Wrap App in a MediaQueryMonitor HOC to avoid complexity
   * instead of declaring it here.
   */
  calcIsNarrow() {
    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
      if (this.props.appearance.isNarrow) {
        this.props.actions.updateNarrowState(false);
      }
    }
    else if (!this.props.appearance.isNarrow) {
      this.props.actions.updateNarrowState(true);
    }
  }

  render() {
    const allProps = this.getAllProps();

    return (
      <AppearanceContext.Provider value={{
        isLoading: this.props.appearance.loading,
        isSubmitLoading: this.props.appearance.submitLoading,
        totalSteps: this.props.appearance.totalSteps,
      }}
      >
        <StickyContainer>
          {this.props.appearance.isNarrow ?
            <Sticky>{ this.getWrappedBookingOverview }</Sticky> :
            <BookingOverview {...allProps} main />
          }

          <BookingStepsContainer {...allProps}>
            <div>
              <RentalInformation {...allProps} />
              <ExtraServices {...allProps} />
            </div>
            <TicketPanels {...allProps} />
            <CustomerContactInfo {...allProps} />
            <AgencySubId {...allProps} />
            <TravelAgencyOptions {...allProps} />
            <PaymentSectionRates {...allProps} />
            <BookingOverview {...allProps} />
          </BookingStepsContainer>
          <AbandonBasketModal {...allProps} />
          {allProps.rental.timeoutModal && (
            <TimeoutModal key="timeoutModalMobile" data={allProps.rental.timeoutModal} mobile={true} />
          )}
          {this.props.appearance.dibsFormArgs !== undefined && this.props.appearance.dibsFormArgs.form !== undefined ?
            <DIBS {...allProps} /> : ''
          }
        </StickyContainer>
      </AppearanceContext.Provider>
    );
  }
}

App.PropTypes = {
  appearance:PropTypes.object.isRequired,
  dispatchScrollToInvalid:PropTypes.func,
  order:PropTypes.object.isRequired,
  rental:PropTypes.object.isRequired,
  errors:PropTypes.object.isRequired,
  actions:PropTypes.object.isRequired,
  validatorFactory:PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    appearance: state.appearanceAppState,
    order: state.orderAppState,
    rental: state.rentalAppState,
    errors: state.errorsState,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      objectAssign({},
        orderActions,
        appearanceActions,
        errorsActions),
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
